import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/mahjongData';

const footerGames = [
  { to: '/category/jingdian-mahjong', label: '经典麻将' },
  { to: '/category/xueliu-chenghe', label: '血流成河' },
  { to: '/category/guangdong-mahjong', label: '广东麻将' },
  { to: '/category/guobiao-mahjong', label: '国标麻将' },
  { to: '/category/changsha-mahjong', label: '长沙麻将' },
  { to: '/category/single-player', label: '单机版麻将' },
];

const footerLinks = [
  { to: '/about', label: '关于我们' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl text-primary-700 cursor-pointer whitespace-nowrap">
              {siteInfo.name}
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              {siteInfo.slogan}
            </p>
            <p className="mt-2 text-xs text-foreground-500">
              已服务 {siteInfo.users} 位麻将爱好者，累计开局 {siteInfo.games} 局
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              <a href="#game-categories" className="cursor-pointer">游戏玩法</a>
            </h4>
            <ul className="space-y-2">
              {footerGames.map((game) => (
                <li key={game.to}>
                  <Link
                    to={game.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {game.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">快速链接</h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/article/mahjong-beginner-guide"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  新手入门指南
                </Link>
              </li>
              <li>
                <Link
                  to="/article/mahjong-health-benefits"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  麻将健康益处
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">联系方式</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                {siteInfo.email}
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-sm"></i>
                </span>
                {siteInfo.phone}
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-wechat-line text-sm"></i>
                </span>
                微信：{siteInfo.wechat}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 免费麻将游戏不下载，打开浏览器即玩
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
              rel="nofollow"
            >
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}